import { useState } from 'react';
import Select from './Select';
import MultiSelect from './MultiSelect';
import Checkbox from './Checkbox';
import SearchInput from './SearchInput';
import RadioGroup from './RadioGroup';

const sortItems = [
    { label: 'Senaste först', value: 'date' },
    { label: 'Äldst först', value: 'rdate' },
    { label: 'Billigast först', value: 'price' },
    { label: 'Dyrast först', value: 'rprice' },
];

const priceItems = (() => {
    let values = [];

    for (let value = 2500; value <= 7500; value+=2500) {
        values.push(value);
    }
    for (let value = 10000; value <= 190000; value+=10000) {
        values.push(value);
    }
    for (let value = 200000; value <= 450000; value+=50000) {
        values.push(value);
    }
    for (let value = 500000; value <= 1000000; value+=100000) {
        values.push(value);
    }

    return values.map((value) => {
        return {label: value.toLocaleString('sv') + ' kr', value: value.toString() };
    })
})();

const priceMinItems = [
    { label: 'Från', value: '' },
    ...priceItems,
];

const priceMaxItems = [
    { label: 'Till', value: '' },
    ...priceItems,
];

const modelYearItems = (() => {
    let values = [];

    const yearMax = new Date().getFullYear() + 1;
    const yearMin = yearMax - 30;

    for (let year = yearMax; year > yearMin; year--) {
        values.push(year);
    }

    return values.map((value) => {
        return {label: value.toString(), value: value.toString() };
    })
})();

const modelYearMinItems = [
    { label: 'Från', value: '' },
    ...modelYearItems,
];

const modelYearMaxItems = [
    { label: 'Till', value: '' },
    ...modelYearItems,
];

const milesItems = (() => {
    let values = [];

    for (let miles = 0; miles <= 40000; miles+=1000) {
        values.push(miles);
    }

    return values.map((value) => {
        return {label: `${value} mil`, value: value.toString() };
    })
})();

const milesMinItems = [
    { label: 'Från', value: '' },
    ...milesItems,
];

const milesMaxItems = [
    { label: 'Till', value: '' },
    ...milesItems,
];

const isNewItems = (facet) => {
    let items = [
        { label: 'Nya och begagnade', value: '' },
    ];

    if (facet) {
        for (let value of facet) {
            if (value.value === '1') {
                items.push({label: `Nya (${value.count})`, value: value.value});
            }
        }
        for (let value of facet) {
            if (value.value === '0') {
                items.push({label: `Begagnade (${value.count})`, value: value.value});
            }
        }
    }

    return items;
}

const checkboxLabel = (label, facet) => {
    if (facet) {
        for (let value of facet) {
            if (value.value === '1') {
                return `${label} (${value.count})`;
            }
        }
    }
    return label;
}

const Filters = ({ facets, filters, setFilters, search, setSearch, setCurrentPage, reset }) => {
    const [expanded, setExpanded] = useState(false);

    const handleChangeSelect = (filter, value) => {
        setFilters(prevState => {
            return {
                ...prevState,
                [filter]: value
            }
        });

        setCurrentPage(1);
    };

    const handleChangeCheckbox = (filter, event) => {
        setFilters(prevState => {
            return {
                ...prevState,
                [filter]: event.target.checked ? '1' : ''
            }
        });

        setCurrentPage(1);
    };

    const handleClickExpanded = () => {
        setExpanded(!expanded);
    };

    const id = Date.now();

    return (
        <div className="search-filters" area-expanded={expanded ? 'true' : 'false'}>
            <div className="search-filters-group first">
                <div className="search-filters-item">
                    <label htmlFor={'type_' + id}>Fordonstyp</label>
                    <MultiSelect id={'type_' + id} placeholder="Alla fordonstyper" items={facets.type} values={filters.type} onChange={(values) => handleChangeSelect('type', values)} />
                </div>
                <div className="search-filters-item">
                    <label htmlFor={'brand_' + id}>Märken</label>
                    <MultiSelect id={'brand_' + id} placeholder="Alla märken" items={facets.brand} values={filters.brand} onChange={(values) => handleChangeSelect('brand', values)} />
                </div>
                <div className="search-filters-item">
                    <label htmlFor={'model_' + id}>Modeller</label>
                    <MultiSelect id={'model_' + id} placeholder="Alla modeller" items={facets.model} values={filters.model} onChange={(values) => handleChangeSelect('model', values)} />
                </div>
                <div className="search-filters-item">
                    <label htmlFor={'city_' + id}>Ort</label>
                    <MultiSelect id={'city_' + id} placeholder="Alla orter" items={facets.city} values={filters.city} onChange={(values) => handleChangeSelect('city', values)} />
                </div>
            </div>
            <div className="search-filters-group second">
                <div className="search-filters-item search">
                    <label htmlFor={'search_' + id}>Sök</label>
                    <SearchInput id={'search_' + id} placeholder="Sök på version, utrustning, etc." value={search} setValue={setSearch} />
                </div>
                <div className="search-filters-item sort">
                    <label htmlFor={'sort_' + id}>Sortera</label>
                    <Select id={'sort_' + id} items={sortItems} value={filters.sort} onChange={(value) => handleChangeSelect('sort', value)} />
                </div>
                <div className="search-filters-item buttons">
                    <button className="button clear" onClick={reset}>Rensa filter</button>
                    <button className="button expand" onClick={handleClickExpanded} area-expanded={expanded ? 'true' : 'false'}>{expanded ? 'Dölj filter' : 'Fler filter'}<i className="fal fa-plus"></i></button>
                </div>
            </div>
            {expanded && (
                <>
                <div className="search-filters-group third">
                    <div className="search-filters-item">
                        <label htmlFor={'fuel_type_' + id}>Drivmedel</label>
                        <MultiSelect id={'fuel_type_' + id} placeholder="Alla drivmedel" items={facets.fuel_type} values={filters.fuel_type} onChange={(values) => handleChangeSelect('fuel_type', values)} />
                    </div>
                    <div className="search-filters-item">
                        <label htmlFor={'gearbox_type_' + id}>Växellåda</label>
                        <MultiSelect id={'gearbox_type_' + id} placeholder="Alla växellådor" items={facets.gearbox_type} values={filters.gearbox_type} onChange={(values) => handleChangeSelect('gearbox_type', values)} />
                    </div>
                    <div className="search-filters-item">
                        <label htmlFor={'color_group_' + id}>Färg</label>
                        <MultiSelect id={'color_group_' + id} placeholder="Alla färger" items={facets.color_group} values={filters.color_group} onChange={(values) => handleChangeSelect('color_group', values)} />
                    </div>
                    <div className="search-filters-item">
                        <label htmlFor={'body_type_' + id}>Kaross</label>
                        <MultiSelect id={'body_type_' + id} placeholder="Alla karosser" items={facets.body_type} values={filters.body_type} onChange={(values) => handleChangeSelect('body_type', values)} />
                    </div>
                </div>
                <div className="search-filters-group fourth">
                    <div className="search-filters-item double">
                        <label htmlFor={'price_' + id}>Pris</label>
                        <div className="select-group flex-row-wrapper from-to">
                            <Select id={'price_' + id} placeholder="Från" items={priceMinItems} value={filters.price_min} onChange={(value) => handleChangeSelect('price_min', value)} />
                            -
                            <Select placeholder="Till" items={priceMaxItems} value={filters.price_max} onChange={(value) => handleChangeSelect('price_max', value)} />
                        </div>
                    </div>
                    <div className="search-filters-item double">
                        <label htmlFor={'model_year_' + id}>Modellår</label>
                        <div className="select-group flex-row-wrapper from-to">
                            <Select id={'model_year_' + id} placeholder="Från" items={modelYearMinItems} value={filters.model_year_min} onChange={(value) => handleChangeSelect('model_year_min', value)} />
                            -
                            <Select placeholder="Till" items={modelYearMaxItems} value={filters.model_year_max} onChange={(value) => handleChangeSelect('model_year_max', value)} />
                        </div>
                    </div>
                    <div className="search-filters-item double">
                        <label htmlFor={'miles_' + id}>Miltal</label>
                        <div className="select-group flex-row-wrapper from-to">
                            <Select id={'miles_' + id} placeholder="Från" items={milesMinItems} value={filters.miles_min} onChange={(value) => handleChangeSelect('miles_min', value)} />
                            -
                            <Select placeholder="Till" items={milesMaxItems} value={filters.miles_max} onChange={(value) => handleChangeSelect('miles_max', value)} />
                        </div>
                    </div>
                    <div className="search-filters-item">
                        <label htmlFor={'is_new_' + id}>Visa</label>
                        <Select id={'is_new_' + id} placeholder="Nya och begagnade" items={isNewItems(facets.is_new)} value={filters.is_new} onChange={(value) => handleChangeSelect('is_new', value)} />
                    </div>
                </div>
                <div className="search-filters-group fifth">
                    <div className="search-filters-item flex-row-wrapper checkboxes">
                        <label>Övrigt</label>
                        <Checkbox label={checkboxLabel('Dragkrok', facets.towbar)} checked={filters.towbar} onChange={(event) => handleChangeCheckbox('towbar', event)} />
                        <Checkbox label={checkboxLabel('Fyrhjulsdrift', facets.four_wheel_drive)} checked={filters.four_wheel_drive} onChange={(event) => handleChangeCheckbox('four_wheel_drive', event)} />
                        <Checkbox label={checkboxLabel('Privatleasing', facets.price_leasing)} checked={filters.price_leasing} onChange={(event) => handleChangeCheckbox('price_leasing', event)} />
                        <Checkbox label={checkboxLabel('Avdragbar moms', facets.price_vat)} checked={filters.price_vat} onChange={(event) => handleChangeCheckbox('price_vat', event)} />
                        <Checkbox label={checkboxLabel('Prissänkt', facets.price_changed)} checked={filters.price_changed} onChange={(event) => handleChangeCheckbox('price_changed', event)} />
                    </div>
                </div>
                </>
            )}
        </div>
    );
}

export default Filters
